import React, { useEffect, useState } from 'react';
import { styled } from "styled-components";
import apiService from '~/service/apiService';
import RefreshImage from '~/assets/refresh.png';

const Wrapper = styled.div`
  padding-right: 20px;
  margin-bottom: 12px;
  
  label {
    
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
  }
  select {
    border: 0px solid;
    display: block;
    width: -webkit-fill-available;
    margin-top: 8px;
    background: #F5F5F5;
    padding: 10px 15px 10px 15px;
    gap: 10px;
    border-radius: 5px;
  }
`;

const LinkGroup = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  .refresh {
    img {
      position: absolute;
      margin-left: -30px;
    }
  }
`;

const DropDown = ({ companyId, id, label, data, content, onChangeEvent, type, jwt }) => {
  const [value, setValue] = useState(content || '');
  const [dataList, setDataList] = useState(data);

  useEffect(() => {
    if (data) {
      const selectedElement = data.find(el => el.selected);
      if (selectedElement) {
        setValue(selectedElement.id);
        onChangeEvent(id, selectedElement.id, type);
      } else if (data.length > 0) {
        // setValue(data[0].id);
        // onChangeEvent(id, data[0].id, type);
        onChangeEvent(id, '', type);
      }
    }
  }, [data]);

  const GetPolicies = (e) => {
    e.preventDefault();

    apiService.get(`/companies/${companyId}/policies/`, jwt).then(newPolicyList => {
      if (newPolicyList && newPolicyList.policies) {
        newPolicyList.policies.forEach(newPolicy => {
          const policyExists = dataList.some(policy => policy.id && policy.id === newPolicy.id);

          if (!policyExists) {
            setDataList(prevDataList => [...prevDataList, newPolicy]);
          }
        });
      }
    });
    return false;
  };

  const onChange = (e) => {
    setValue(e.target.value);
    if (onChangeEvent) {
      onChangeEvent(id, e.target.value, type);
    }
  };
  const dashboardUrl = process.env.REACT_APP_DASHBOARD_BASE_URL || 'https://dashboard.easyllama.com'

  return (
    <Wrapper>
      <label>{label ? `${label}: ` : ''}</label>
      <select key={`dropdown_${id}`} value={value} onChange={onChange}>
        <option key={`drop_opt_`} value={''}>Please select</option>
        {dataList.map(el => {
          return <option key={`drop_opt_${el.id}`} value={el.id}>{el.name}</option>
        })}
      </select>
      <LinkGroup>
        <a href={`${dashboardUrl}/companies/${companyId}/policies`} target='_blank' rel="noreferrer">Upload new policies</a>
        <a href='/get_policy' onClick={GetPolicies} className='refresh'>
          <img src={RefreshImage} alt='' />
          Refresh policy list</a>
      </LinkGroup>
    </Wrapper>
  );
};

export default DropDown;
